import Social from './Social.vue';
export default Social;



// WEBPACK FOOTER //
// ./src/components/parts/share/index.ts